import { urlFix, queryFix } from './utils';

const parse = url => (url.indexOf('?') === -1 ? [url, null] : url.split('?'));

const join = (url, type, ...args) => {
  const [route, query] = parse(url);
  if (type === 'query') return `${route}?${query ? `${query}&` : ''}${args.map(queryFix).join('&')}`;
  return `${route}/${args.map(urlFix).join('/')}${query ? `?${query}` : ''}`;
};

const netPath = url => ({
  join: (...args) => netPath(join(url, 'url', ...args)),
  joinQuery: (...args) => netPath(join(url, 'query', ...args)),
  toString: () => url,
});

export default netPath;
